<template>
    <div class="modal-box" v-loading="loading">
        <div class="modal-box-inner">
            <div class="modal-box-header" v-if="this.header">
                <span class="modal-box-header-title">
                    edit password
                </span>
                <a class="modal-box-header-back" @click.prevent="close()">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14" viewBox="0 0 14 14"><defs><clipPath id="clip-path"><rect width="14" height="14" fill="none"/></clipPath></defs><g id="Icon_-_Close" data-name="Icon - Close" clip-path="url(#clip-path)"><path id="ic_close_24px" d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z" transform="translate(-5 -5)" fill="#444"/></g></svg>
                </a>
            </div>
            <div class="modal-box-content add-user">
                <el-form ref="form" :rules="rules" :model="form" @submit.prevent.native="formSubmit('form')">

                    <el-form-item prop="password">
                        <el-input v-model="form.password" type="password" placeholder="password"></el-input>
                    </el-form-item>

                    <div class="modal-box-action">
                        <button v-if="typeof this.data.user === 'undefined'" native-type="submit" type="primary" class="modal-box-action-item button">Add User</button>
                        <button v-else native-type="submit" type="primary" class="modal-box-action-item button">Update</button>

                        <button native-type="button" @click.prevent="close" type="text" class="modal-box-action-item link">Cancel</button>
                    </div>

                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'
import { EventBus } from '@/services/eventbus'

export default {
  props: {
    header: {
      type: [Boolean, Object]
    },
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  name: 'PasswordUpdateModal',
  data () {
    return {
      loading: false,
      form: {
        password: null
      },
      rules: {
        password: [
          { required: true, message: 'Please enter user\'s new password', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (typeof this.data.user !== 'undefined') {
      this.form.id = this.data.user.id
    }
  },
  mounted () {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.close()
      }
    })
  },
  methods: {
    formSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          HTTP({
            method: 'PUT',
            url: '/api/v1/users/password',
            crossdomain: true,
            data: this.form
          })
            .then(response => {
              this.loading = false
              if (response.data) {
                this.$notify({
                  // title: 'Success',
                  message: 'User updated',
                  type: 'success',
                  position: 'bottom-right',
                  duration: 1750
                })
                this.close()
                EventBus.$emit('reload-users')
              }
            })
            .catch(error => {
              this.loading = false
              this.$notify({
                // title: 'Error',
                dangerouslyUseHTMLString: true,
                message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
                type: 'error',
                position: 'bottom-right',
                duration: 1750
              })
            })
        } else {
          return false
        }
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>
